import {Component} from '@angular/core';
import {blocks} from './blocks';
import {RouterLink} from "@angular/router";
import {StatusProtocol} from "@models/sportexam";
import {CanWatchDirective} from "@directives/can-watch.directive";

@Component({
    selector   : 'app-main',
    imports: [
        RouterLink,
        CanWatchDirective
    ],
    templateUrl: './main.component.html',
    styleUrl   : './main.component.scss'
})
export class MainComponent {

    readonly blocks = blocks;
    protected readonly StatusProtocol = StatusProtocol;
}
